<template>
  <router-view />
</template>

<script setup lang="ts">
/**
 * 嵌套路由出口：仅渲染子路由的 router-view，用于无独立页面的父级路由（如 task、project）。
 * 避免父级无 component 导致子路由匹配异常或 404。
 */
</script>
